import { breakthroughMeds } from '@components/app/ListingPage/ListingHero/consts'

export const getBreakthroughTrialStatus = ({
  description,
  primaryTreatment,
}: {
  description: string
  primaryTreatment: string
}): boolean => {
  return breakthroughMeds.some(
    (med) =>
      primaryTreatment.toLowerCase().includes(med.toLowerCase()) ||
      description.toLowerCase().includes(med.toLowerCase()),
  )
}
